import { matchPath } from 'react-router-dom';

export const V2_APP_URL = (process.env.REACT_APP_V2_APP_URL || 'https://v2.contimo.app').replace(/\/+$/, '');

type Params = Record<string, string | undefined>;

interface V2RouteMapping {
  patterns: string[];
  label: string;
  toV2: (params: Params, companyId: string) => string;
}

const dashboard = (_: Params, companyId: string) => `/c/${companyId}/dashboard`;

// Single place to map V1 routes to their V2 equivalents. First match wins.
const V2_ROUTE_MAPPINGS: V2RouteMapping[] = [
  {
    patterns: ['/', '/waiting', '/ready', '/active'],
    label: 'Dashboard',
    toV2: dashboard,
  },
  {
    patterns: ['/campaigns'],
    label: 'Campaigns Performance',
    toV2: (_, companyId) => `/c/${companyId}/campaigns`,
  },
  {
    patterns: ['/campaigns/:campaignId/*', '/marketplace-campaigns/:campaignId/*'],
    label: 'Campaign',
    toV2: ({ campaignId }, companyId) => `/c/${companyId}/campaigns/${encodeURIComponent(campaignId!)}`,
  },
  {
    patterns: ['/create/campaign/*', '/create/display-campaign/*'],
    label: 'New Campaign',
    toV2: (_, companyId) => `/c/${companyId}/campaigns/new`,
  },
];

const FALLBACK: V2RouteMapping = { patterns: ['*'], label: 'Dashboard', toV2: dashboard };

export interface V2Destination {
  url: string;
  label: string;
  matchedPattern: string;
}

export function getV2Destination(pathname: string, companyId: string): V2Destination {
  for (const mapping of V2_ROUTE_MAPPINGS) {
    for (const pattern of mapping.patterns) {
      const match = matchPath(pattern, pathname);
      if (match) {
        return {
          url: V2_APP_URL + mapping.toV2(match.params, companyId),
          label: mapping.label,
          matchedPattern: pattern,
        };
      }
    }
  }
  return {
    url: V2_APP_URL + FALLBACK.toV2({}, companyId),
    label: FALLBACK.label,
    matchedPattern: FALLBACK.patterns[0],
  };
}

export const getV2CampaignReportUrl = (companyId: string, campaignId: string) =>
  `${V2_APP_URL}/c/${companyId}/campaigns/${campaignId}/report`;
